export default __webpack_public_path__ + "img/de.87119b19.svg";